/*@ngInject*/
const ScoringRuleActionsUtil = function ($rootScope, $stateParams, $state, $q, loadingBarHandler, configurationMediator, scoringRulesEditorModel, modalUtil, coreConstant) {

    this.save = function (translations, scoringRule) {
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'saveScoringRule.loadingBar'));
        if(scoringRule.id === -1){
            scoringRule.id = null;
        }
        return configurationMediator.saveScoringRule(scoringRule).then(function (savedScoringRule) {
            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveScoringRule.savingScoringRuleSuccessLoadingBar'));
            $state.go('configuration.manageScoringRules', { scoringRuleId: savedScoringRule.id}, {reload: true});
            return savedScoringRule;
        });
    };


    this.discard = function (translations) {
        modalUtil.showConfirmationModal(null, null, null, 'scoringRulesEditorHeader.discardConfirmation', null, true, function () {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'discardConfirmation.success'));
            scoringRulesEditorModel.setUnsavedChanges($stateParams.scoringRuleId, false);
            if ($stateParams.scoringRuleId && $stateParams.scoringRuleId !== '-1') {
                $state.reload();
            } else {
                $state.go('configuration.scoringRulesBrowser', {});
            }
        });
    };

    this.delete = function (translations, scoringRuleId) {
        modalUtil.showConfirmationModal(null, null, null, 'scoringRulesEditorHeader.deleteConfirmation', null, true, function () {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'deleteConfirmation.loadingBar'));
            return configurationMediator.deleteScoringRule(scoringRuleId).then(function () {
                scoringRulesEditorModel.setUnsavedChanges(scoringRuleId, false);
                loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'deleteConfirmation.success'));
                $state.go('configuration.scoringRulesBrowser', {});
            });
        });
    };

    this.copy = function (translations, scoringRule) {
        modalUtil.showConfirmationModal(null, null, null, 'scoringRulesEditorHeader.copyScoringRuleConfirmation', null, true, function () {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'copyScoringRuleConfirmation.loadingBar'));
            scoringRule.id = null;
            return configurationMediator.saveScoringRule(scoringRule).then(function (copiedScoringRule) {
                scoringRulesEditorModel.setUnsavedChanges($stateParams.scoringRuleId, false);
                $state.go('configuration.manageScoringRules', {scoringRuleId: copiedScoringRule.id});
                loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'copyScoringRuleConfirmation.success'));
            });
        });
    };
};

angular.module('ums.configuration')
    .service('scoringRuleActionsUtil', ScoringRuleActionsUtil);
